import React from "react";

function HomeNL() {
  return <div>Home</div>;
}
export default HomeNL;
